import { useState } from "react";

const links = [
  { label: "今日新瓜", href: "#hot" },
  { label: "首发速递", href: "#express" },
  { label: "今日更新", href: "#today" },
  { label: "社区热议", href: "#community" },
  { label: "吃瓜分区", href: "#circles" },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        {/* brand */}
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-foreground-950 text-background-50">
            <i className="ri-flashlight-fill text-lg" />
          </span>
          <span className="leading-none">
            <h1 className="text-xl font-extrabold tracking-tight text-foreground-950">最全黑料</h1>
            <span className="mt-0.5 block text-[11px] text-foreground-500">每日刷新 · 新瓜首发速递</span>
          </span>
        </a>

        {/* desktop links */}
        <nav className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* right actions */}
        <div className="flex items-center gap-2.5">
          <div className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3.5 py-2 md:flex">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="text"
              placeholder="搜新瓜 / 搜人物"
              className="w-36 bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
          </div>
          <a
            href="#report"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-edit-2-fill text-sm" />
            <span className="hidden sm:inline">我要爆料</span>
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 lg:hidden"
          >
            <i className={`text-lg ${open ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3.5 py-2">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="text"
              placeholder="搜新瓜 / 搜人物"
              className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
          </div>
          <div className="flex flex-col">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}